<div id="login-page" class="primary-background">
  <div id="login-form">
    <div *ngIf="attributesForm" [hidden]="setPassword">
      <p-card>
        <div class="input-card-body" [formGroup]="attributesForm">
          <label class="app-label" style="margin-bottom: 2rem">{{
            'password_confirm_attributes' | translation
          }}</label>
          <ng-container *ngFor="let attribute of attributeKeys">
            <app-input
              [control]="attributesForm.get(attribute)"
              [label]="attributeDisplayName(attribute)"
              [placeholder]="attributeDisplayName(attribute)">
            </app-input>
          </ng-container>
          <div class="button-holder">
            <app-button status="secondary" (click)="location.back()">
              {{ 'cancel' | translation }}
            </app-button>

            <app-button
              status="primary"
              (click)="continueToPasswordStep()"
              [disabled]="stillRequiredAttributes()">
              {{ 'continue' | translation }}
            </app-button>
          </div>
        </div>
      </p-card>
    </div>

    <p-card *ngIf="setPassword">
      <label class="app-label">{{ 'password_new_set' | translation }}</label>
      <ng-container *ngIf="!policies || !passwordForm; else loaded">
        <div class="new-password-loading-spinner">
          <app-loading-dots size="5px"></app-loading-dots>
        </div>
      </ng-container>
      <ng-template #loaded>
        <div class="input-card-body">
          <div style="margin-bottom: 2rem">
            <p>{{ 'required' | translation }}:</p>
            <p
              *ngIf="policies?.MinimumLength > 0"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.minlength),
              }">
              {{ 'requirement_minimum_length' | translation }}:
              {{ policies?.MinimumLength }}
            </p>
            <p
              *ngIf="policies?.RequireUppercase"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.mustHaveUpercase),
              }">
              {{ 'requirement_uppercase' | translation }}
            </p>
            <p
              *ngIf="policies?.RequireLowercase"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.mustHaveLowercase),
              }">
              {{ 'requirement_lowercase' | translation }}
            </p>
            <p
              *ngIf="policies?.RequireNumbers"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.mustHaveNumber),
              }">
              {{ 'requirement_number' | translation }}
            </p>
            <p
              *ngIf="policies?.RequireSymbols"
              [ngClass]="{
                'strike-through':
                  passwordForm.get('newPw').dirty &&
                  (!passwordForm.get('newPw').errors ||
                    !passwordForm.get('newPw').errors.mustHaveSpecialCharacter),
              }">
              {{ 'requirement_special_character' | translation }}
            </p>
          </div>
          <app-input
            [control]="passwordForm.get('oldPw')"
            [label]="'password_old' | translation"
            [placeholder]="'password_old' | translation"
            [hideInput]="true">
          </app-input>

          <app-input
            [control]="passwordForm.get('newPw')"
            [label]="'password_new' | translation"
            [placeholder]="'password_new' | translation"
            [hideInput]="true">
          </app-input>
          <app-input
            [control]="passwordForm.get('confirmPw')"
            [label]="'password_confirm' | translation"
            [placeholder]="'password_confirm' | translation"
            [hideInput]="true"
            (enterKey)="onConfirmPasswordEnter($event)">
          </app-input>

          <password-strength-meter
            (strengthChange)="passwordStrength = $event"
            style="display: block"
            [minPasswordLength]="policies?.MinimumLength || 7"
            [enableFeedback]="true"
            [password]="
              passwordForm.get('newPw').value
            "></password-strength-meter>

          <div class="button-holder">
            <app-button
              status="secondary"
              (click)="backFromPasswordStep()">
              {{ 'back' | translation }}
            </app-button>
            <app-button
              [isProcessing]="isProcessing"
              status="primary"
              (click)="submitNewPw()"
              [disabled]="passwordForm.invalid || isProcessing">
              {{ 'submit' | translation }}
            </app-button>
          </div>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>
